/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '@ngx-translate/core/src/translate.pipe';
import * as i2 from '@ngx-translate/core/src/translate.service';
import * as i3 from '../../../../src/app/components/topnav.component';
import * as i4 from 'ngx-bootstrap/dropdown/bs-dropdown.state';
import * as i5 from 'ngx-bootstrap/dropdown/bs-dropdown.directive';
import * as i6 from 'ngx-bootstrap/component-loader/component-loader.factory';
import * as i7 from 'ngx-bootstrap/dropdown/bs-dropdown.config';
import * as i8 from 'ngx-bootstrap/dropdown/bs-dropdown-toggle.directive';
import * as i9 from 'ngx-bootstrap/dropdown/bs-dropdown-menu.directive';
import * as i10 from '../../../../src/app/modules/auth/auth.service';
var styles_TopNavComponent = [];
export var RenderType_TopNavComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_TopNavComponent, data: {} });
function View_TopNavComponent_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 5, 'ul', [['class',
                'dropdown-menu']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 2, 'li', [], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.logout() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['', ''])),
        i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                    ']))], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 3, 0, i0.ɵnov(_v, 4).transform('Logout'));
        _ck(_v, 3, 0, currVal_0);
    });
}
export function View_TopNavComponent_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 49, 'div', [['class',
                'row border-bottom shadow-bottom white-bg invisible-element topnav']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 14, 'div', [['class',
                'col-sm-4 col-md-8 col-request-user']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 10, 'div', [['class', 'navbar-header']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 4, 'span', [['minimaliza-sidebar', '']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(),
            i0.ɵeld(0, null, null, 1, 'span', [['class', 'navbar-minimalize minimalize-styl-2 btn btn-primary ']], null, [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (_co.minimalize() !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'fa fa-bars']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 1, 'h1', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Uptime'])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 30, 'div', [['class', 'col-sm-8 col-md-4 col-info-user']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 27, 'nav', [['class', 'navbar navbar-static-top white-bg'], ['role',
                'navigation'], ['style', 'margin-bottom: 0']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 24, 'div', [['class', 'nav navbar-top-links right-nav'], ['id', 'top-user-box']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 7, 'a', [['class', 'user-profile-link pt-user']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'span', [['class', 'user-name']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Philippe Hammond'])),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'span', [['class', 'user-corp']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Unbrella Corp'])), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(16777216, null, null, 12, 'div', [['class', 'user-menu'], ['dropdown',
                '']], [[2, 'dropup', null], [2, 'open', null], [2, 'show',
                null]], null, null, null, null)),
        i0.ɵprd(512, null, i4.BsDropdownState, i4.BsDropdownState, []),
        i0.ɵdid(212992, null, 0, i5.BsDropdownDirective, [i0.ElementRef, i0.Renderer,
            i0.ViewContainerRef, i6.ComponentLoaderFactory, i7.BsDropdownConfig, i4.BsDropdownState], null, null), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'expand-menu'],
            ['dropdownToggle', '']], [[1, 'aria-haspopup', 0], [1, 'disabled', 0], [1, 'aria-expanded',
                0]], [[null, 'click'], ['document', 'click'], [null, 'keyup.esc']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 38).onClick() !== false);
                ad = (pd_0 && ad);
            }
            if (('document:click' === en)) {
                var pd_1 = (i0.ɵnov(_v, 38).onDocumentClick($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('keyup.esc' === en)) {
                var pd_2 = (i0.ɵnov(_v, 38).onEsc() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(147456, null, 0, i8.BsDropdownToggleDirective, [i4.BsDropdownState, i0.ElementRef], null, null), (_l()(),
            i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 0, 'span', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, [' \n                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_TopNavComponent_1)),
        i0.ɵdid(16384, null, 0, i9.BsDropdownMenuDirective, [i4.BsDropdownState,
            i0.ViewContainerRef, i0.TemplateRef], null, null), (_l()(),
            i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(),
            i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n'])),
        (_l()(), i0.ɵted(null, ['\n']))], function (_ck, _v) {
        _ck(_v, 35, 0);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵnov(_v, 35).dropup;
        var currVal_1 = i0.ɵnov(_v, 35).isOpen;
        var currVal_2 = (i0.ɵnov(_v, 35).isOpen && i0.ɵnov(_v, 35).isBs4);
        _ck(_v, 33, 0, currVal_0, currVal_1, currVal_2);
        var currVal_3 = true;
        var currVal_4 = i0.ɵnov(_v, 38).isDisabled;
        var currVal_5 = i0.ɵnov(_v, 38).isOpen;
        _ck(_v, 37, 0, currVal_3, currVal_4, currVal_5);
    });
}
export function View_TopNavComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'cx-topnav', [], null, null, null, View_TopNavComponent_0, RenderType_TopNavComponent)),
        i0.ɵdid(49152, null, 0, i3.TopNavComponent, [i10.AuthService], null, null)], null, null);
}
export var TopNavComponentNgFactory = i0.ɵccf('cx-topnav', i3.TopNavComponent, View_TopNavComponent_Host_0, {}, {}, []);
//# sourceMappingURL=topnav.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./aot/src/app/components/topnav.component.ngfactory.js
// module id = 1184
// module chunks = 0